import { useSelector } from '@/stores/hooks'
import { getAllPois } from '@/stores/pois'
import { useMemo } from 'react'
import { useLoadPoisByType } from '../load/useLoadPoisByType'

export function useDataPoisByType(
	type: string,
	{ level = 0, disable = false }: { level?: number; disable?: boolean } = {},
) {
	const load = useLoadPoisByType(type, { level, disable })
	const data = useSelector(state => getAllPois(state))
	const pois = useMemo(
		() => Object.values(data).filter(x => x.category === type),
		[type, data],
	)
	return { ...load, pois }
}
